export const table_header = [
    {
      th_name: "planet",
      th_classname: "col-1 text-center position-sticky table-cell-bg start-0",
    },
    {
      th_name: "planet_name",
      th_classname: "col-3",
    },
    {
        th_name: "address",
        th_classname: "col-2",
      },
    {
      th_name: "contact_name",
      th_classname: "col-2",
    },
    {
      th_name: "contact_email",
      th_classname: "col-2",
    },
    {
      th_name: "contact_phone",
      th_classname: "col-2",
    },
    {
      th_name: "action",
      th_classname: "col-2 text-center position-sticky table-cell-bg end-0",
    },
  ]